import { render, staticRenderFns } from "./processSetting.vue?vue&type=template&id=7654770c&scoped=true&"
import script from "./processSetting.vue?vue&type=script&lang=js&"
export * from "./processSetting.vue?vue&type=script&lang=js&"
import style1 from "./processSetting.vue?vue&type=style&index=1&id=7654770c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7654770c",
  null
  
)

export default component.exports